<template>
  <main class="bg-image-outer-wrapper" id="app">
    <headerMenu></headerMenu>
    <router-view />
    <lang></lang>
    <icon></icon>
    <footerMenu></footerMenu>
  </main>
</template>
<script>
import headerMenu from "@/components/Header";
import footerMenu from "@/components/Footer";
import lang from "@/components/Lang";
import icon from "@/components/Icon";

export default {
  components: {
    headerMenu,
    footerMenu,
    lang,
    icon,
  },
};
</script>
<style lang="scss">
@import "./style/style.scss";
</style>
